module.exports = __webpack_public_path__ + "img/download.7afecc2e.svg";